var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C9.20937 8 11 6.20937 11 4C11 1.79063 9.20937 0 7 0C4.79062 0 3 1.79063 3 4C3 6.20937 4.79062 8 7 8ZM9.79999 9H9.27812C8.58437 9.31875 7.8125 9.5 7 9.5C6.1875 9.5 5.41875 9.31875 4.72187 9H4.2C1.88125 9 0 10.8812 0 13.2V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V13.2C14 10.8812 12.1187 9 9.79999 9ZM19.8937 4.9875L19.025 4.10938C18.8812 3.9625 18.6469 3.9625 18.5 4.10625L15.225 7.35625L13.8031 5.925C13.6594 5.77813 13.425 5.77813 13.2781 5.92188L12.4 6.79375C12.2531 6.9375 12.2531 7.17187 12.3969 7.31875L14.95 9.89062C15.0937 10.0375 15.3281 10.0375 15.475 9.89375L19.8906 5.5125C20.0344 5.36562 20.0375 5.13125 19.8937 4.9875Z",
    fill: "#0869E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserUnlock);
export default __webpack_public_path__ + "static/media/UserUnlock.29e24881e3c46d8c30947385e2adb935.svg";
export { ForwardRef as ReactComponent };